export default "__VITE_ASSET__DEo51Ai3__"